import { format } from 'date-fns'
import { parseDate } from './utils'

/**
 * Format DateTime value using the format expected by the DateTime input (YYYY-MM-DDTHH:MM)
 */
export default function formatForDatetimeInput(dateString: string | null): string {
  const date = parseDate(dateString)
  return date ? format(date, "yyyy-MM-dd'T'HH:mm") : ''
}
